import { COST_METRICS_LAST_UPDATED_AT_S3_PREFIX, COST_METRICS_S3_PREFIX, FinTechOpsCategories } from '../../FinTechOpsConstants';
import { returnParsedAndFormattedCostMetricsData } from '../../cost-metrics/CostMetricsDataProcessing';
import { CostMetricsParsedDetails, CostMetricsRawData } from '../../cost-metrics/CostMetricsInterface';
import { useS3Dataset, UseS3DatasetResult } from './useS3Dataset';

export const useCostMetricsData = (): UseS3DatasetResult<CostMetricsParsedDetails> =>
  useS3Dataset<CostMetricsRawData[], CostMetricsParsedDetails>({
    prefix: COST_METRICS_S3_PREFIX,
    lastUpdatedPrefix: COST_METRICS_LAST_UPDATED_AT_S3_PREFIX,
    category: FinTechOpsCategories.costMetrics,
    parse: returnParsedAndFormattedCostMetricsData
  });
